const prefix = process.env.NODE_ENV === 'production' ? '' : 'dev-';
export const INVITE_TOKEN_KEY = `${prefix}inviteToken`;
